import React from "react";
import { ScoodleDefaultPage } from "../../../04templates/scoodle/defaultPage/ScoodleDefaultPage";
import { H1 } from "pu-crossproduct-components/build/components/Atoms/Type";
import { GridContainer, GridItem, GridRow } from "pu-crossproduct-components/build/components/Atoms/Grid";
import { Trans, useTranslation } from "react-i18next";
import { Button, ButtonColors, Emphasis, Size } from "pu-crossproduct-components/build/components/Molecules/Navigation/Button";
import styled from "styled-components";
import { Logo, Logos } from "pu-crossproduct-components/build/components/Atoms/Icons/Logo";
import acmLogo from "../Scoodle2FAExplanation/illus_2FA_3.svg";

const ButtonContainer = styled.div`
    button {
        width: 383px;
    }
`;

const AccountDataContainer = styled.div`
    width: 100%;
    margin: 50px 0;

    img {
        width: 85px;
        height: 104px;
    }
`

const VerticalSpacer = styled.div`
    background: #FF817B;
    width: 1px;
    height: 330px;
    margin-left: auto;
    margin-right: auto;
`

const AcmLogo = styled.img`
    width: 164px !important;
    height: 104px !important;
`;

export interface IAccountData {
    givenName: string;
    familyName: string;
    emailAddress: string;
    acmGivenName: string;
    acmFamilyName: string;
}

interface IScoodle2FASetupConfirm {
    accountData : IAccountData,
    onConfirm : () => void;
    onReject : () => void;
}

export const Scoodle2FASetupConfirm: React.FC<IScoodle2FASetupConfirm> = props => {
    const { t } = useTranslation();

    return <ScoodleDefaultPage>
        <H1>{t('twoFactorScoodleSetupConfirmTitle')}</H1>

        <AccountDataContainer>
            <GridContainer>
                <GridRow>
                    <GridItem col={5} style={{textAlign:"right"}}>
                        <Logo logo={Logos.scoodle} /><br />
                        <br />
                        {t('twoFactorScoodleSetupConfirmScoodleEmailAddress')}<br/>
                        <strong>{props.accountData.emailAddress}</strong><br/>
                        <br/>
                        {t('twoFactorScoodleSetupConfirmScoodleFamilyName')}<br/>
                        <strong>{props.accountData.familyName}<br/></strong>
                        <br/>
                        {t('twoFactorScoodleSetupConfirmScoodleGiveName')}<br/>
                        <strong>{props.accountData.givenName}</strong>
                    </GridItem>
                    <GridItem col={2}>
                        <VerticalSpacer />
                    </GridItem>
                    <GridItem col={5}>
                        <AcmLogo src={acmLogo} /><br />
                        <br/>
                        <br/>
                        <strong></strong><br/>
                        <br/>
                        {t('twoFactorScoodleSetupConfirmACMFamilyName')}<br/>
                        <strong>{props.accountData.acmFamilyName}<br/></strong>
                        <br/>
                        {t('twoFactorScoodleSetupConfirmACMGiveName')}<br/>
                        <strong>{props.accountData.acmGivenName}</strong>
                    </GridItem>
                </GridRow>
            </GridContainer>
        </AccountDataContainer>

        <ButtonContainer>
            <Button size={Size.large} onClick={props.onConfirm}>{t('twoFactorScoodleSetupConfirmConfirmButton')}</Button><br/>
            <Button color={ButtonColors.secondary} size={Size.large} onClick={props.onReject}>{t('twoFactorScoodleSetupConfirmRejectButton')}</Button>
        </ButtonContainer>
    </ScoodleDefaultPage>
}